import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { getAlgoliaId, getAlgoliaUserToken } from '@mode/shared/util-js';
import { SearchSettingsModel } from '../+state/algolia-search.models';
import { AlgoliaSearchState } from '../+state/algolia-search.reducer';
import { Store } from '@ngrx/store';
import * as AlgoliaSearchSelectors from '../+state/algolia-search.selectors';

@Injectable()
export class AlgoliaSearchFacade {
  settings$: Observable<SearchSettingsModel | null>;

  public readonly algoliaAppId: string = getAlgoliaId(window.document, true) ?? '';
  public readonly algoliaUserToken: string = getAlgoliaUserToken(window.document, true) ?? '';

  constructor(private store: Store<AlgoliaSearchState>) {
    this.settings$ = store.select(AlgoliaSearchSelectors.selectAlgoliaSearchSettings);
  }
}
